/**
 * `MATH_EXERCISE_EDITORS` — the single registration point for the math exercise sub-forms, the same
 * pattern as the assessment editor's `INTERACTION_EDITORS`.
 *
 * `Record<MathExerciseType, Component>` is exhaustive: not `Partial`, no index signature, so a
 * seventh exercise type fails `pnpm typecheck` until an editor is registered, where a `v-if` chain on
 * the type would silently render nothing.
 *
 * Every editor takes the same one prop (`MathExerciseEditorProps`), which is what makes one
 * dispatcher legitimate.
 */
import type { Component } from 'vue'

import { MathExerciseType } from '../../../../../model/assignments/enums'
import ExerciseMultipleChoice from './ExerciseMultipleChoice.vue'
import ExerciseNumeric from './ExerciseNumeric.vue'
import ExerciseMatchPairs from './ExerciseMatchPairs.vue'
import ExerciseOrder from './ExerciseOrder.vue'
import ExerciseNumberLine from './ExerciseNumberLine.vue'
import ExerciseMultiStep from './ExerciseMultiStep.vue'

export const MATH_EXERCISE_EDITORS: Record<MathExerciseType, Component> = {
  [MathExerciseType.MultipleChoice]: ExerciseMultipleChoice,
  [MathExerciseType.Numeric]: ExerciseNumeric,
  [MathExerciseType.MatchPairs]: ExerciseMatchPairs,
  [MathExerciseType.Order]: ExerciseOrder,
  [MathExerciseType.NumberLine]: ExerciseNumberLine,
  [MathExerciseType.MultiStep]: ExerciseMultiStep,
}
